module.exports = __webpack_public_path__ + "img/frequency-tool.cb1332f8.png";